import { checkFeatureFlag } from 'config'

export const hideAssistedRegistration = checkFeatureFlag("hide-assisted-registration")
export const forceFullUserCreationInDashboard = checkFeatureFlag("force-full-user-creation-in-dashboard")
export const FIRST_AGENT_TAB = hideAssistedRegistration ? 'agent' : 'registrationType'
